/**
 * @desc 获取所有已部署流程定义信息
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<Array<defs.activiti.BpmDefinitionDto>>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/bpm/proc/deploy/defs`, {
      method: "GET",

      ...options,
    }),
  );
}
